<div
    class="pointer-events-none border-2 border-blurple rounded-xl absolute cursor-pointer z-30 px-[5px] pt-[5px] bg-[linear-gradient(to_bottom,transparent_40px,white_40px)]"
    [ngStyle]="{
        'width.px': width,
        'height.px': outlineHeight,
    }">
    <div
        class="rounded-lg h-9 w-9 flex items-center justify-center bg-blurple-light"
        [ngClass]="{ 'opacity-50': partnerAvailable }">
        <i class="pi pi-check text-white/100"></i>
    </div>
</div>
